module.exports = __webpack_public_path__ + "static/media/W6@1.5x.9e5da605.png";